import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { useModuleAccess } from "@pos/shared";
import { toast } from "@pos/ui";
import { ROUTE_MODULE_MAP } from "@/config/route-module-map";

export function ModuleGuardLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { modules, hasModule } = useModuleAccess();

  const requiredModule = ROUTE_MODULE_MAP[location.pathname];
  // Allow access while profiles are still loading (modules empty)
  const loading = modules.length === 0;
  const allowed = loading || !requiredModule || hasModule(requiredModule);

  useEffect(() => {
    if (!allowed) {
      toast.error("You don't have access to this page");
      navigate("/", { replace: true });
    }
  }, [allowed, navigate]);

  if (!allowed) {
    return null;
  }

  return <Outlet />;
}
